import React from "react";
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Routes from "./routes"
import { Button, notification } from 'antd';
import PrivateRoute from "./components/PrivateRoute/privateRoute"
import "./App.css"
import config from "./config";
import DataStore from "./utils/db";
import { getRemember, clearRemember, clearRememberUser } from "./utils/Session";
import EventEmitter from 'wolfy87-eventemitter';
import Login from "./pages/login";
import Net from "./utils/net";

const {
	getFileFormat, BusinessStatusLabel, AccountingStatusLabel, StatusColor,
	ModalFullStyle, ModalFullBodyStyle, ModalMainStyle, ModalFormStyle, ModalContainer,
	ModalPageTitleStyle, ModalFooterStyle,
} = config;
global.ModalFullStyle = ModalFullStyle;
global.ModalFullBodyStyle = ModalFullBodyStyle;
global.ModalMainStyle = ModalMainStyle;
global.ModalFormStyle = ModalFormStyle;
global.ModalContainer = ModalContainer;
global.ModalPageTitleStyle = ModalPageTitleStyle;
global.ModalFooterStyle = ModalFooterStyle;
global.getFileFormat = getFileFormat;

global.renderLabel = (label, showStar) => {
	return (
		<>
			{showStar && <span style={{ color: "#F00", }}>*</span>}{label}：
		</>
	)
};

global.renderModuleLabel = (label) => {
	return (
		<>
			<div style={{
				textAlign: "center", fontWeight: "bold", fontSize: 15, padding: "10px 0", marginTop: 10, borderTop: "2px solid #333", borderBottom: "0.5px solid #333",
			}}>{label}</div>
		</>
	)
};

global.renderModuleLine = () => {
	return <div style={{ height: 2, background: "#333", marginTop: 10 }} />;
};

global.setProcessList = (doc) => {
	let list = doc.processList || [];
	list.sort((a, b) => {
		a.actionTime = a.actionTime || a.time;
		b.actionTime = b.actionTime || b.time;
		return b.actionTime - a.actionTime;
	});
	return list;
};

global.getBusinessStatus = (status) => {
	if (status === 99) {
		return "已作废";
	} else if (status) {
		return BusinessStatusLabel[status - 1];
	}
	return null;
};

global.getAccountingStatus = (status) => {
	if (status === 99) {
		return "已作废";
	} else if (status) {
		return AccountingStatusLabel[status - 1];
	}
	return null;
};

global.getBusinessStatusColor = (status) => {
	// let statusColor = "#354F9E";
	let statusColor = StatusColor[3];
	if (status === 1) {
	} else if (status === 2) {
		statusColor = StatusColor[2];
	} else if (status === 3) {
		statusColor = StatusColor[0];
	} else if (status === 99) {
		statusColor = StatusColor[4];
	}
	// FieldValue.status === 1 ? "blue" : FieldValue.status === 2 ? "green" : "red"
	return statusColor;
}

global.getAccountingStatusColor = (status) => {
	// let statusColor = "#354F9E";
	let statusColor = StatusColor[3];
	if (status === 1) {
	} else if (status === 2) {
		statusColor = StatusColor[1];
	} else if (status === 3) {
		statusColor = StatusColor[0];
	} else if (status === 4) {
		statusColor = StatusColor[2];
	} else if (status === 99) {
		statusColor = StatusColor[4];
	}
	return statusColor;
};

global.delParam = (paramKey) => {
	var url = window.location.href;    //页面url
	var urlParam = window.location.search.substr(1);   //页面参数
	var beforeUrl = url.substr(0, url.indexOf("?"));   //页面主地址（参数之前地址）
	var nextUrl = "";

	var arr = new Array();
	if (urlParam != "") {
		var urlParamArr = urlParam.split("&"); //将参数按照&符分成数组
		for (var i = 0; i < urlParamArr.length; i++) {
			var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
			//如果键雨要删除的不一致，则加入到参数中
			if (paramArr[0] != paramKey) {
				arr.push(urlParamArr[i]);
			}
		}
	}
	if (arr.length > 0) {
		nextUrl = "?" + arr.join("&");
	}
	url = beforeUrl + nextUrl;
	return url;
};

String.prototype.replaceAll = function (s1, s2) {
	return this.replace(new RegExp(s1, "gm"), s2);
}

global.isString = function (str) {
	return (typeof str == 'string') && str.constructor == String;
}

function accDiv(arg1, arg2) {
	let t1 = 0, t2 = 0, t3 = 0, r1, r2;
	try {
		t1 = arg1.toString().split(".")[1].length
	} catch (e) {
	}
	try {
		t2 = arg2.toString().split(".")[1].length
	} catch (e) {
	}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	if (r2 === 0)
		return 0;
	let result = String(r1 / r2);
	try {
		t3 = result.toString().split(".")[1].length
	} catch (e) {
	}
	let index = t2 - t1 - t3;
	if (index < 0) {
		result = result.replace(".", "");
		while (result.length <= Math.abs(index)) {
			result = '0' + result;
		}
		let start = result.substring(0, result.length + index);
		let end = result.substring(result.length + index, result.length);
		result = start + '.' + end;
		return Number(result);
	} else if (index > 0) {
		result = result.replace(".", "");
		while (result.length <= Math.abs(index)) {
			result += '0';
		}
		return Number(result);
	} else return Number(result.replace(".", ""));
}

//给Number类型增加一个div方法，调用起来更加方便。
//除法
Number.prototype.div = function (arg) {
	return accDiv(this, arg);
};

function accMul(arg1, arg2) {
	let m = 0, s1 = arg1.toString(), s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length
	} catch (e) {
	}
	try {
		m += s2.split(".")[1].length
	} catch (e) {
	}
	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)

}

// 乘法
Number.prototype.mul = function (arg) {
	return accMul(arg, this);
};

function accAdd(arg1, arg2) {
	let r1, r2, m, c;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	c = Math.abs(r1 - r2);
	m = Math.pow(10, Math.max(r1, r2));
	if (c > 0) {
		let cm = Math.pow(10, c);
		if (r1 > r2) {
			arg1 = Number(arg1.toString().replace(".", ""));
			arg2 = Number(arg2.toString().replace(".", "")) * cm;
		} else {
			arg1 = Number(arg1.toString().replace(".", "")) * cm;
			arg2 = Number(arg2.toString().replace(".", ""));
		}
	} else {
		arg1 = Number(arg1.toString().replace(".", ""));
		arg2 = Number(arg2.toString().replace(".", ""));
	}
	return (arg1 + arg2) / m

}

// 加法
Number.prototype.add = function (arg) {
	return accAdd(arg, this);
};

//减法函数，用来得到精确的减法结果
// 说明：javascript的减法结果会有误差，在两个浮点数相加的时候会比较明显。这个函数返回较为精确的减法结果。
// 调用：accSub(arg1,arg2)
// 返回值：arg1减去arg2的精确结果
function accSub(arg1, arg2) {
	let r1, r2, m, n;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	m = Math.pow(10, Math.max(r1, r2));
	//last modify by deeka
	// 动态控制精度长度
	n = (r1 >= r2) ? r1 : r2;
	return Number(((arg2 * m - arg1 * m) / m).toFixed(n));
}

//给Number类型增加一个add方法，调用起来更加方便。
Number.prototype.sub = function (arg) {
	return accSub(arg, this);
};

global.setFee = (fee) => {
	if (fee != null) {
		return Number(fee).toFixed(2);
	}
	return fee;
};

global.userIsAdmin = function (userInfo) {
	if (userInfo && userInfo.loginName === "admin") {
		return true;
	}
	return false;
}

global.getOperatorList = (type) => {
	let temp = global.OperatorList || [];
	let list = temp.filter(item => item._id === "QITA" || item.linkBusiness && item.linkBusiness.includes(type));
	console.log("getOperatorList", list)
	// list.push({ name: "其他", _id: "QITA" })
	return list;
};

global.setBusinessTypeOptions = (operatorId, type) => {
	let list = [];
	for (let i = 0; i < global.BusinessTypeList.length; i++) {
		let item = global.BusinessTypeList[i];
		if (item) {
			let operatorIdArr = item.operatorId || [];
			let linkBusiness = item.linkBusiness || [];
			if (operatorIdArr.includes(operatorId) || item._id === "QITA") {
				if (linkBusiness.length === 0) {
					list.push(item);
				} else if (linkBusiness.includes(type)) {
					list.push(item);
				}
			}
		}
	}
	return list;
};

global.openNotification = (info) => {
	const key = `${info.type}${Date.now()}`;
	const btn = (
		<Button type="primary" size="small" onClick={() => notification.destroy(key)}>
			{info.btnString || "关闭"}
		</Button>
	);
	notification[info.type]({
		message: info.message || "",
		description: info.description || "",
		duration: 0,
		key,
		btn,
		onClick: () => {
			// console.log('Notification Clicked!');
		},
	});
};

global.CustomerList = [];
global.PartnerList = [];
global.OperatorList = [];
global.BusinessTypeList = [];

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
		global.loadCustomer = this.loadCustomer.bind(this);
		global.loadPartner = this.loadPartner.bind(this);
		global.loadOperator = this.loadOperator.bind(this);
		global.loadBusinessType = this.loadBusinessType.bind(this);
		global.loadProject = this.loadProject.bind(this);
	};
	UNSAFE_componentWillMount() {
		global.EE = new EventEmitter();
		global.isDev = process.env.NODE_ENV === 'development';
		const baseUrl = global.isDev ? config.baseUrl.dev : config.baseUrl.pro;
		console.log(baseUrl);
		const baseFileUrl = global.isDev ? config.baseFileUrl.dev : config.baseFileUrl.pro;
		DataStore.BaseUrl = baseUrl;
		global.ServerUrl = baseUrl;
		global.BaseFileUrl = baseFileUrl;
		let rememberMe = getRemember();
		if (rememberMe) {
			if (rememberMe.autoLoginTime) {
				let nowTime = new Date().getTime();
				let stamp = nowTime - rememberMe.autoLoginTime;
				let dayCount = stamp / (24 * 60 * 60 * 1000);
				console.log('dayCount', dayCount);
				if (dayCount > 7) {
					console.log("dayCount > 7 goToLogin");
					this.goToLogin();
				} else {
					if (rememberMe.autoLogin) {
						global.loginUser = rememberMe.user;
						Net.post(global.ServerUrl + 'user/token', { token: global.loginUser.token }, res => {
							if (res.ret) {
								global.loginUser = res.ret;
							} else {
								this.goToLogin();
							}
						});
					} else {
						console.log("!rememberMe.autoLogin goToLogin");
						this.goToLogin();
					}
				}
			}
		} else {
			if (!global.loginUser) {
				console.log("!rememberMe goToLogin");
				this.goToLogin();
			}
		}
		console.log("app.js UNSAFE_componentWillMount loginUser", global.loginUser);
	}

	componentDidMount() {
		global.EE = new EventEmitter();
		global.isDev = process.env.NODE_ENV === 'development';
		const baseUrl = global.isDev ? config.baseUrl.dev : config.baseUrl.pro;
		const baseFileUrl = global.isDev ? config.baseFileUrl.dev : config.baseFileUrl.pro;
		const templateUrl = global.isDev ? config.templateUrl.dev : config.templateUrl.pro;
		DataStore.BaseUrl = baseUrl;
		global.ServerUrl = baseUrl;
		global.BaseFileUrl = baseFileUrl;
		global.TemplateUrl = templateUrl;
		this.loadBaseInfo();
	}

	loadBaseInfo = () => {
		this.loadCustomer();
		this.loadPartner();
		this.loadOperator();
		this.loadBusinessType();
		this.loadProject();
	};

	loadCustomer = () => {
		new DataStore("Customer").loadAll().then(res => {
			console.log("loadCustomer res", res);
			res = res || [];
			res.sort((a, b) => {
				return a.companyName.localeCompare(b.companyName, "zh");
			});
			global.CustomerList = res;
			global.CustomerObj = {};
			for (let i = 0; i < res.length; i++) {
				const item = res[i];
				global.CustomerObj[item._id] = item;
			}
		}).catch(error => {
			console.log("loadCustomer error", error)
		});
	}
	loadPartner = () => {
		new DataStore("Partner").loadAll().then(res => {
			res = res || [];
			global.PartnerList = res;
			global.PartnerObj = {};
			for (let i = 0; i < res.length; i++) {
				const item = res[i];
				global.PartnerObj[item._id] = item;
			}
		}).catch(error => {
			console.log("loadPartner error", error)
		});
	}
	loadOperator = () => {
		new DataStore("Operator").loadAll().then(res => {
			res = res || [];
			res.push({ _id: "QITA", name: "其他" });
			global.OperatorList = res;
			global.OperatorObj = {};
			for (let i = 0; i < res.length; i++) {
				const item = res[i];
				global.OperatorObj[item._id] = item;
			}
		}).catch(error => {
			console.log("loadOperator error", error)
		});
	}
	loadBusinessType = () => {
		new DataStore("BusinessType").loadAll().then(res => {
			res = res || [];
			res.push({ _id: "QITA", name: "其他" });
			global.BusinessTypeList = res;
			global.BusinessTypeObj = {};
			for (let i = 0; i < res.length; i++) {
				const item = res[i];
				global.BusinessTypeObj[item._id] = item;
			}
		}).catch(error => {
			console.log("loadBusinessType error", error)
		});
	}
	loadProject = () => {
		new DataStore("Project").loadAll().then(res => {
			res = res || [];
			global.ProjectList = res;
			global.ProjectObj = {};
			for (let i = 0; i < res.length; i++) {
				const item = res[i];
				global.ProjectObj[item._id] = item;
			}
		}).catch(error => {
			console.log("loadProject error", error)
		});
	}

	goToLogin = () => {
		clearRemember();
		let rememberMe = getRemember();
		if (rememberMe) {
			clearRememberUser();
		}
		let url = global.delParam("token");
		window.location.href = url + '/#/login';
	}


	render() {
		return (
			<Router>
				<Switch>
					<Route path="/login" component={Login} />
					<PrivateRoute path="/sys" component={Routes} />
					<Redirect exact from="/" to="/login" />
				</Switch>
			</Router>
		)
	}
}

export default App;
